<div class="container ">
  <!-- Header -->
  <div style="display:flex ">
      <div class="header ">
          Remote Service Software
      </div>
      <div style="padding-top: 15px; ">
          <img id="leica-logo-img " class="leica-logo" src="../../assets/icons/leica-logo.svg" alt="leica-logo " />
      </div>
      
 
  </div>
  <div class="content-wrapper">
    <img class="warning" src="../../assets/icons/Warning.svg" alt="warning"/>
    <p class="UnauthText">{{"UnauthText" | transloco}}</p>
  </div>

  <div class="button-wrapper">
    <button id="confirm-buttom-confirm-popup" class="action-btn white-text" (click)="loginRedirect()">Login</button>
  </div>
</div>